import { render } from "./MyModal.vue?vue&type=template&id=b81a35d8&scoped=true"
import script from "./MyModal.vue?vue&type=script&lang=js"
export * from "./MyModal.vue?vue&type=script&lang=js"

import "./MyModal.vue?vue&type=style&index=0&id=b81a35d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81a35d8"]])

export default __exports__